export default {
  newUserID: '54', //新用户id
  oldUserID: '55', //老用户id

  // newUserID: '36', //新用户id 测试
  // oldUserID: '39', //老用户id
}
